// What the /story route should show for the `clay-value-story-v1` deck snapshot. Pure so the three
// outcomes are testable without a DOM; the localStorage read stays in the route component.

import { migrateDeckSnapshot } from '../../../engine/migrate-v3';
import type { ValueStory } from '../../../engine/value-story-schema';

/** Written by the calculator when a deck is generated. Same key as v2; v3 stories are `v: 2`. */
export const STORY_KEY = 'clay-value-story-v1';

export type StoryRouteState =
  | { kind: 'story'; story: ValueStory }
  /** A v2 snapshot: no engine math in the deck, so the SE reopens the calculator to refresh it. */
  | { kind: 'legacy' }
  | { kind: 'empty' };

export function resolveStoryRoute(raw: string | null): StoryRouteState {
  if (!raw) return { kind: 'empty' };
  const m = migrateDeckSnapshot(raw);
  if (m.kind === 'story') return { kind: 'story', story: m.story };
  if (m.kind === 'legacy') return { kind: 'legacy' };
  return { kind: 'empty' };
}
